import {
  AIR_ACCELERATE,
  AIR_CAP,
  FRICTION,
  GRAVITY,
  GROUND_ACCELERATE,
  JUMP_VELOCITY,
  MAX_SPEED,
  STOP_SPEED,
} from './constants';

/**
 * Mutable runtime copy of the feel-critical movement constants, edited live by
 * the tuning panel (T). `constants.ts` stays the committed source of truth —
 * values that survive playtesting get written back there (ROADMAP Phase 2).
 */
export interface MovementTuning {
  gravity: number;
  airAccelerate: number;
  groundAccelerate: number;
  friction: number;
  stopSpeed: number;
  maxSpeed: number;
  airCap: number;
  jumpVelocity: number;
}

export const TUNING_DEFAULTS: Readonly<MovementTuning> = Object.freeze({
  gravity: GRAVITY,
  airAccelerate: AIR_ACCELERATE,
  groundAccelerate: GROUND_ACCELERATE,
  friction: FRICTION,
  stopSpeed: STOP_SPEED,
  maxSpeed: MAX_SPEED,
  airCap: AIR_CAP,
  jumpVelocity: JUMP_VELOCITY,
});

export const tuning: MovementTuning = { ...TUNING_DEFAULTS };

export function resetTuning(): void {
  Object.assign(tuning, TUNING_DEFAULTS);
}
